import React, { useState } from "react";

import { useLazyQuery } from "@apollo/client";
import { useQuery } from "@apollo/client";
import get from "lodash/get";
import PropTypes from "prop-types";
import { PRODUCT, PRODUCT_BY_REF } from "shared/graphql/queries";
import { RULES } from "shared/graphql/rule/queries";
import { useInfo } from "utils/hooks/info";

import View from "./View";

const Component = ({ setActiveStep, onChange }) => {
  const {
    commonInfo: { unknownProductCode },
  } = useInfo();

  const queryRules = useQuery(RULES, {
    variables: {
      where: { productCode: unknownProductCode, ruleType: "MASKS" },
    },
  });

  const [productError, setProductError] = useState();

  const [getProducts, queryProducts] = useLazyQuery(PRODUCT, {
    fetchPolicy: "network-only",
    onError: (error) => {
      const _error = get(error.graphQLErrors, "[0].extensions");
      setProductError(_error);
    },
  });
  const [getProductByRef, queryProductRef] = useLazyQuery(PRODUCT_BY_REF);

  return (
    <View
      setActiveStep={setActiveStep}
      queryProducts={{ ...queryProducts, error: productError }}
      queryProductRef={queryProductRef}
      queryRules={queryRules}
      setProductError={setProductError}
      getProducts={getProducts}
      getProductByRef={getProductByRef}
      onChange={onChange}
    />
  );
};

Component.propTypes = {
  onChange: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
};

Component.defaultProps = {};

export default Component;
